/* unplugin-vue-components disabled */import script from "./UserInfoDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserInfoDialog.vue?vue&type=script&setup=true&lang=ts"

import "./UserInfoDialog.vue?vue&type=style&index=0&id=19a8163d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19a8163d"]])

export default __exports__